import Swal from 'sweetalert2'

import { otnHtml } from './otnHtml'
import {
  makeAjaxCall,
  handleDataOfDelay,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
} from '../../utils/functions'
import { lang } from '../../assets/lang'

const page_table_id = window.xitFlowBuilderData.page_table_id
const base_url = window.xitFlowBuilderData.base_url

export const otnModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.otn_modal_title,
    html: otnHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      const otnTitleElement = $('#otn-otn-title')
      const otnPostbackElement = $('#otn-otn-postbackId')

      otnTitleElement.val(oldData.otnTitleValue || '')

      otnPostbackElement.on('change', function() {
        Swal.resetValidationMessage()
        const currentValue = $(this).val()
        if ('newOtn' === oldData.otnPostbackIdValue && 'newOtn' !== currentValue) {
          node.otnPostbackIdValueChangeStatus = true
          Swal.showValidationMessage(lang.otn_html_sequence_info)
        }
      })
 
      const ajaxOtnData = {
        url: base_url+'visual_flow_builder/get_dropdown_otn',
        data: {
          page_table_id
        }
      }

      makeAjaxCall(function(response) {
        $("#otn-otn-postbackId").html(response.dropdown_str);
        $('#otn-otn-postbackId').val(oldData.otnPostbackIdValue || '').trigger('change')
      }, ajaxOtnData)

      // Handles old data of delay system
      handleOldDataOfDelay(oldData)
    },

    preConfirm: () => {
      const otnTitleValue = $('#otn-otn-title').val()
      const otnPostbackIdValue = $('#otn-otn-postbackId').val()
      const otnPostbackIdText = $( "#otn-otn-postbackId option:selected" ).text()
      
      if (! otnTitleValue) {
        Swal.showValidationMessage(lang.otn_modal_msg_title)
      }
      
      if (! otnPostbackIdValue) {
        Swal.showValidationMessage(lang.otn_modal_msg_postback_id)
      }

      // Handles data of delay system
      const delayData = handleDataOfDelay()

      return {
        otnTitleValue, 
        otnPostbackIdValue, 
        otnPostbackIdText, 
        ...delayData,
      }
    },
  })
}